// // import React from "react";
// // import "./process.css";
// // import { FaRegCalendarAlt, FaChartBar, FaPencilAlt, FaLaptopCode } from "react-icons/fa";

// // const WorkProcess = () => {
// //   const processSteps = [
// //     { id: 1, title: "Discover", icon: <FaRegCalendarAlt />,content:"Understand the problem, define project goals, and gather requirements—whether it's a web platform, IoT device, or both"},
// //     { id: 2, title: "Plan & Architect", icon: <FaChartBar />,content:"Design the system architecture, tech stack, and data flow for optimal performance and scalability." },
// //     { id: 3, title: "Build", icon: <FaPencilAlt />,content:"Code the frontend/backend for web apps and develop embedded systems or smart devices using microcontrollers." },
// //     { id: 4, title: "Deploy & Iterate", icon: <FaLaptopCode />,content: "Launch, monitor, and refine the product using feedback and real-time data from devices or users."}
// //   ];

// //   return (
// //     <div className="work-process">
// //       <div className="work-text">
// //         <h2>Work Process</h2>
// //         <p>
// //         From idea to deployment, I follow a practical and agile workflow that brings both digital and physical projects to life.
// //         </p>
// //       </div>
// //       <div className="work-cards">
// //         {processSteps.map((step, index) => (
// //           <div key={step.id} className="work-card">
// //             <div className="icons">{step.icon}</div>
// //             <h4>{step.id}. {step.title}</h4>
// //             <p>{step.content}</p>
// //           </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // };

// // export default WorkProcess;
// import React from "react";
// import "./process.css";
// import { FaRegCalendarAlt, FaChartBar, FaPencilAlt, FaLaptopCode } from "react-icons/fa";

// const WorkProcess = () => {
//   const processSteps = [
//     {
//       id: 1,
//       title: "Discover",
//       icon: <FaRegCalendarAlt />,
//       content:
//         "I start by understanding your business goals and project requirements. Whether it's a responsive website, a custom web application, or a smart IoT device, I gather detailed insights to define a clear roadmap."
//     },
//     {
//       id: 2,
//       title: "Plan & Architect",
//       icon: <FaChartBar />,
//       content:
//         "I design the full system architecture, choose the right tech stack, and plan databases and APIs to ensure high performance, scalability, and maintainability."
//     },
//     {
//       id: 3,
//       title: "Develop & Build",
//       icon: <FaPencilAlt />,
//       content:
//         "I build clean, responsive frontend interfaces and robust backend systems for your web app. For IoT and embedded systems, I develop smart device firmware and integrate hardware and software seamlessly."
//     },
//     {
//       id: 4,
//       title: "Deploy & Optimize",
//       icon: <FaLaptopCode />,
//       content:
//         "I deploy your website or application to secure cloud servers, set up continuous monitoring, and use real-time feedback to optimize performance and user experience."
//     }
//   ];

//   return (
//     <div className="work-process">
//       <div className="work-text">
//         <h2>My Web Development Process</h2>
//         <p>
//           My step-by-step web development workflow ensures every <strong>website</strong>, <strong>web application</strong>, or <strong>IoT project</strong> is delivered efficiently, meeting modern standards for quality and performance.
//         </p>
//       </div>
//       <div className="work-cards">
//         {processSteps.map((step) => (
//           <div key={step.id} className="work-card">
//             <div className="icons">{step.icon}</div>
//             <h4>{step.id}. {step.title}</h4>
//             <p>{step.content}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default WorkProcess;
import React from "react";
import "./process.css";
import { FiSearch, FiLayers, FiCode, FiCloud } from "react-icons/fi";
import { motion } from "framer-motion";

const WorkProcess = () => {
  const processSteps = [
    {
      id: 1,
      title: "Research",
      icon: <FiSearch />,
      content: "Deep dive into your business objectives and technical requirements",
      // color: "#6366f1"
    },
    {
      id: 2,
      title: "Architect",
      icon: <FiLayers />,
      content: "Design scalable system architecture and select optimal technologies",
      // color: "#10b981"
    },
    {
      id: 3,
      title: "Build",
      icon: <FiCode />,
      content: "Develop clean, efficient code with modern frameworks and best practices",
      // color: "#f59e0b"
    },
    {
      id: 4,
      title: "Deploy",
      icon: <FiCloud />,
      content: "Launch with CI/CD pipelines and cloud infrastructure for reliability",
      // color: "#3b82f6"
    }
  ];

  return (
    <div className="process-deck-container">
      <div className="process-header">
        <h2>Development Process</h2>
        <p className="process-subtitle">
          How we transform <span>ideas</span> into <span>digital solutions</span>
        </p>
      </div>

      <div className="card-deck">
        {processSteps.map((step, index) => (
          <motion.div 
            key={step.id}
            className="process-card"
            style={{ 
              backgroundColor: step.color,
              zIndex: processSteps.length - index
            }}
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ 
              delay: index * 0.1,
              duration: 0.5,
              type: "spring",
              stiffness: 100
            }}
            whileHover={{
              y: -15,
              rotateZ: index % 2 === 0 ? 2 : -2,
              scale: 1.05,
              zIndex: 100
            }}
          >
            <div className="card-icon">{step.icon}</div>
            <h3>{step.title}</h3>
            <p>{step.content}</p>
            <div className="card-number">0{step.id}</div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default WorkProcess;